import { render, staticRenderFns } from "./HelpSVG.vue?vue&type=template&id=d1b5d630&"
import script from "./HelpSVG.vue?vue&type=script&lang=js&"
export * from "./HelpSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports